import React from 'react';
import './allProjekts.sass';
import { Line } from '../../../line/line';
import { AllProjectsWeb } from './projects';
import { Quotes } from '../../../quotes/quotes';



export const AllProjects = () => {
    return(
        <>
            <div className="All_projects">
                <div>
                    {/* All projects */}
                    <h2 id="All_projects_h2">Все проекты</h2>
                    <Line />
                </div>
                <div className="All_projects_adaptivnost">
                    <AllProjectsWeb />                  
                </div>
            </div>
            <div className="quotesAllProjects">
                <Quotes text="Сегодня ты делаешь код, завтра код делает тебе деньги" 
                author="«Steve Jobs»" />
            </div>
        </>
    )
}